import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import { PageContainer } from "core/components/PageContainer";
import { useTranslation } from "react-i18next";

export function NotFound404Page({ alertMessage }: { alertMessage?: string }) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:NotFound404Page",
  });
  return (
    <PageContainer maxWidth={false}>
      {alertMessage && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {alertMessage}
        </Alert>
      )}
      <Typography variant="h3" color="error.main">
        {t("title")}
      </Typography>
    </PageContainer>
  );
}
